import type { RouteRecordRaw } from 'vue-router';

export default {
  meta: { feature: 'buckets' },
  path: 'buckets/create',
  name: 'bucket/create',
  component: () => import('@/views/dashboard/storages/buckets/create/index.vue'),
} satisfies RouteRecordRaw;
